import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import axios from 'axios';
import ApiLink from 'API';

// Loads a protected chat image via the authenticated /file route as a blob
// (an <img src> can't carry the token header), then renders an object URL.
export default function AuthImage({ roomId, messageId, alt = '', onClick, sx }) {
    const [url, setUrl] = useState('');
    const [error, setError] = useState(false);
    const objUrlRef = useRef('');

    useEffect(() => {
        let cancelled = false;
        setUrl('');
        setError(false);
        axios
            .get(`${ApiLink}/api/chat/file/${roomId}/${messageId}`, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') },
                responseType: 'blob',
            })
            .then((res) => {
                if (cancelled) return;
                const obj = URL.createObjectURL(res.data);
                objUrlRef.current = obj;
                setUrl(obj);
            })
            .catch(() => !cancelled && setError(true));
        return () => {
            cancelled = true;
            if (objUrlRef.current) URL.revokeObjectURL(objUrlRef.current);
        };
    }, [roomId, messageId]);

    if (error) {
        return (
            <Box sx={{ width: 180, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'action.hover', borderRadius: 1, color: 'text.disabled' }}>
                <BrokenImageIcon />
            </Box>
        );
    }
    if (!url) {
        return (
            <Box sx={{ width: 180, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'action.hover', borderRadius: 1 }}>
                <CircularProgress size={20} />
            </Box>
        );
    }
    return (
        <Box
            component="img"
            src={url}
            alt={alt}
            onClick={onClick}
            sx={{ maxWidth: 220, maxHeight: 220, borderRadius: 1, cursor: 'pointer', display: 'block', ...sx }}
        />
    );
}

// Imperatively fetch a file blob and trigger a browser download (auth-protected).
export async function downloadChatFile(roomId, messageId, filename) {
    const res = await axios.get(`${ApiLink}/api/chat/file/${roomId}/${messageId}`, {
        withCredentials: true,
        headers: { token: localStorage.getItem('token') },
        responseType: 'blob',
    });
    const obj = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = obj;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(obj), 1000);
}
